<template>
  <div>
    <Head title="Productos" />
    <h1 class="mb-8 text-3xl font-bold">Crear devolución</h1>
    
    <div class="bg-white rounded-xl shadow overflow-hidden">
      <div class="p-5">
        <text-input placeholder="Buscar por numero de factura" class="w-full" />
        <loading-button :loading="form.processing" class="btn-blue mt-2" type="submit">Buscar</loading-button>
      </div>

    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '../../Shared/LoadingButton.vue'

export default {
  components: {
    Head,
    Icon,
    Link,
    TextInput,
    LoadingButton,
  },
  layout: Layout,
  props: {
    products: Object,
  },
  data(){
    return {
      form: this.$inertia.form({

      })
    }
  },
  methods: {
    searchOrder() {
      
    },
    generate(){
      this.quantities.post('/returns')
    },
  },

}
</script>
